export const calculatePadding = (windowWidth, padding) => {
  return windowWidth <= 768 ? (padding / 2.4).toFixed(0) : padding;
};